<app-header></app-header>
<ion-content
  id="product-usage-page"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <div class="page-content-wrapper">
    <div
      class="header-wrapper"
      *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
    >
      <app-breadcrumb activePageName="Product Usage"></app-breadcrumb>
      <ion-grid fixed="true">
        <ion-row class="title-row">
          <ion-col>
            <h1 class="page-title">PRODUCT USAGE</h1>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="content-container">
      <div class="error-toast-container">
        <app-report-toast-container></app-report-toast-container>
      </div>
      <ion-grid fixed="true">
        <ion-row
          class="toast-container"
          *ngIf="(platformService?.platformType === platformService?.platformEnum?.tablet) 
        || (platformService?.platformType === platformService?.platformEnum?.mobile)"
        >
          <ion-col>
            <app-data-usage-warning></app-data-usage-warning>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ng-container *ngIf="noData">
        <div class="no-data-container">
          <h2 class="no-data-title">There is no data to show</h2>
          <p class="no-data-label">
            Please adjust your <span class="no-data-label-link">filters</span>.
          </p>
        </div>
      </ng-container>
      <app-report-table
        [dataSource]="dataSource"
        [columnsToDisplay]="columnsToDisplay"
        *ngIf="!noData && dataLoaded"
      ></app-report-table>
      <ng-container *ngIf="!dataLoaded">
        <div class="table-skeleton-container">
          <ion-skeleton-text
            *ngFor="let bar of [1,2,3,4,5,6,7,8,9,10,11,12]"
            class="row-skeleton"
            animated
          ></ion-skeleton-text>
        </div>
      </ng-container>
    </div>
  </div>
  <app-footer></app-footer>
</ion-content>
